(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('kendo.core.js'), require('kendo.spreadsheet-common.cmn.chunk.js')) :
    typeof define === 'function' && define.amd ? define(['exports', 'kendo.core', 'kendo.spreadsheet-common.cmn.chunk'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory((global.kendo = global.kendo || {}, global.kendo._globals = global.kendo._globals || {}, global.kendo._globals.SpreadsheetCommon = {}), global.kendo._globals.Core, global.kendo._globals.SpreadsheetCommonCmnChunk));
})(this, (function (exports, kendo_core_js, kendo_spreadsheetCommon_cmn_chunk_js) {
    const __meta__ = {
        id: "spreadsheet.common",
        name: "SpreadsheetCommon",
        category: "web",
        description: "A reusable outputed chunk of code",
        depends: ['core', 'spreadsheet-common.cmn.chunk'],
        hidden: true,
        chunk: true,
        
    };

    (function(kendo) {
        let $ = kendo.jQuery;
        $.extend(kendo.spreadsheet, kendo_spreadsheetCommon_cmn_chunk_js.c);
        kendo.spreadsheet.commonEngine = kendo_spreadsheetCommon_cmn_chunk_js.c;
    })(kendo);

    exports.__meta__ = __meta__;

}));
